<app-view-associteexit></app-view-associteexit>
<app-associate-exit-checklist-screen *ngIf="roleName == 'HRM'"></app-associate-exit-checklist-screen>